function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon Design - Merged"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.5 11h-8a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v8a.5.5 0 01-.5.5zM3 10h7V3H3zM10.5 22h-8a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v8a.5.5 0 01-.5.5zM3 21h7v-7H3zM21.5 11h-8a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v8a.5.5 0 01-.5.5zM14 10h7V3h-7zM17.5 22a4.5 4.5 0 114.5-4.5 4.505 4.505 0 01-4.5 4.5zm0-8a3.5 3.5 0 103.5 3.5 3.504 3.504 0 00-3.5-3.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})));